export default {
  data() {
    return {
      civilitiesConst: [
        {label: 'Monsieur', value: 'M'},
        {label: 'Madame', value: 'MME'},
        {label: 'Madame et Monsieur', value: 'MME_M'},
        {label: 'Madame et Madame', value: 'MME_MME'},
        {label: 'Monsieur et Monsieur', value: 'M_M'},
        {label: this.$t('undefined'), value: undefined},
      ],
      civilitiesIconConst: [
        {label: 'Monsieur', value: 'M', icon: 'ga-male'},
        {label: 'Madame', value: 'MME', icon: 'ga-female'},
        {label: 'Madame et Monsieur', value: 'MME_M', icon: 'ga-male-female'},
        {label: 'Madame et Madame', value: 'MME_MME', icon: 'ga-female-female'},
        {label: 'Monsieur et Monsieur', value: 'M_M', icon: 'ga-male-male'},
        {label: this.$t('undefined'), value: undefined},
      ],
      civilitiesConstForProspect: [
        {label: 'Monsieur', value: 'M'},
        {label: 'Madame', value: 'MME'},
        {label: 'Madame et Monsieur', value: 'MME_M'},
        {label: 'Madame et Madame', value: 'MME_MME'},
        {label: 'Monsieur et Monsieur', value: 'M_M'},
        {label: this.$t('undefined'), value: undefined},
      ],
    };
  },
  methods: {
    displayForCivilityConst(value, returnLabel = '') {
      let result = this.civilitiesConst.find((el) => el.value === value);
      return result ? result.label : returnLabel;
    },
    getCivilitiesConstForProspect() {
      return this.civilitiesConstForProspect;
    },
  },
};
